import { Logger, LogLevel } from '@repo/utils/common';

import { appEnv } from '@/shared/configs/app.config';
import type { UserInfoResult } from '@/shared/types/fetch.types';
import { makeZodSafeFetchWithRefreshToken } from '@/shared/utils/common.utils';
import { userInfoResultSchema } from '@/shared/validation/fetch.validation';

const logger = new Logger(LogLevel.DEBUG);

let userInfoPromise: Promise<UserInfoResult> | null = null;

export const getUser = async (): Promise<UserInfoResult> => {
  if (!userInfoPromise) {
    userInfoPromise = makeZodSafeFetchWithRefreshToken(
      `${appEnv.VITE_API_URL}/config/user`,
      userInfoResultSchema,
      { credentials: 'include' },
    )
      .then((data) => {
        if (!data) {
          throw new Error('Failed to fetch user');
        }

        return data;
      })
      .catch((error) => {
        logger.error(error);
        userInfoPromise = null;
        return { user: null };
      });
  }

  return userInfoPromise;
};
